import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

export async function fetchClients({
  search = "",
  source = "",
  dateFrom = "",
  dateTo = "",
} = {}) {
  const response = await axios.get(`${config.dev}/v2/clients`, {
    headers: authHeaders(),
    params: {
      ...(search ? { search } : {}),
      ...(source ? { source } : {}),
      ...(dateFrom ? { dateFrom } : {}),
      ...(dateTo ? { dateTo } : {}),
    },
  });
  return response.data;
}

export async function fetchArchivedClients({ search = "" } = {}) {
  const response = await axios.get(`${config.dev}/v2/clients/archived`, {
    headers: authHeaders(),
    params: {
      ...(search ? { search } : {}),
    },
  });
  return response.data;
}

export async function fetchClientDetail(clientId) {
  const response = await axios.get(
    `${config.dev}/v2/clients/${encodeURIComponent(clientId)}`,
    { headers: authHeaders() }
  );
  return response.data;
}

export async function archiveClient(clientId, client) {
  const response = await axios.put(
    `${config.dev}/v2/clients/${encodeURIComponent(clientId)}/archive`,
    { client },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function restoreClient(clientId) {
  const response = await axios.put(
    `${config.dev}/v2/clients/${encodeURIComponent(clientId)}/restore`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function deleteArchivedClient(clientId) {
  const response = await axios.delete(
    `${config.dev}/v2/clients/${encodeURIComponent(clientId)}`,
    { headers: authHeaders() }
  );
  return response.data;
}
